export enum Checkmark {
  Green = 'green',
  Blue = 'blue',
}

export type CheckListProps = {
  className?: string;
  items: string[];
  checkmark?: Checkmark;
  useHtml?: boolean;
};
